<template>
  <div>Login...</div>
</template>

<script>
export default {
  mounted() {
    this.$store
      .dispatch('auth/request', this.$route.params.code)
      .then(() => {
        this.$router.push({ name: 'Welcome' })
      })
      .catch(() => {
        this.$router.push({ name: 'Login' })
      })
  }
}
</script>
